import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  NEW_PREVENTIVE_TASK_PATH,
  PREVENTIVE_TASK_PATH,
} from '../../../../config/paths';
import { PREVENTIVE_TASK_COLUMNS } from '../../../../config/columns';
import {
  clearPreventiveTasks,
  getPreventiveTasks,
} from '../../../../actions/task-schedule/PreventiveTask';

export const PreventiveTasks = ({
  breadcrumbs,
  preventiveTasks,
  loading,
  dispatchGetPreventiveTasks,
  dispatchClearPreventiveTasks,
}) => {
  useLayoutEffect(() => () => dispatchClearPreventiveTasks(), []);

  const data = preventiveTasks.get('content') || [];
  const pages = preventiveTasks.get('totalPages') || null;
  const defaultPageSize = preventiveTasks.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Tareas Programadas"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_PREVENTIVE_TASK_PATH}
      tableStructure={{
        columns: PREVENTIVE_TASK_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetPreventiveTasks,
        modelPath: PREVENTIVE_TASK_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetPreventiveTasks: getPreventiveTasks,
  dispatchClearPreventiveTasks: clearPreventiveTasks,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Tareas Programadas',
      href: PREVENTIVE_TASK_PATH,
    },
  ],
  preventiveTasks: TaskScheduleUnit.PreventiveTask.getIn(['all', 'content']),
  loading: TaskScheduleUnit.PreventiveTask.getIn(['all', 'loading']),
});

PreventiveTasks.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  preventiveTasks: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetPreventiveTasks: PropTypes.func.isRequired,
  dispatchClearPreventiveTasks: PropTypes.func.isRequired,
};

PreventiveTasks.defaultProps = {
  preventiveTasks: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(PreventiveTasks);
